import { Variants } from 'framer-motion';

export const variants: Variants = {
	open: { opacity: 1 },
	close: { opacity: 0 },
};
